import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M12 19v-7l-5 -7m10 0l-5 7","key":"svg-0"}],["path",{"d":"M8 17l8 0","key":"svg-1"}],["path",{"d":"M8 13l8 0","key":"svg-2"}]]

/**
 * IconCurrencyYen
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItY3VycmVuY3kteWVuIgo+CiAgPHBhdGggc3Ryb2tlPSJub25lIiBkPSJNMCAwaDI0djI0SDB6IiBmaWxsPSJub25lIiAvPgogIDxwYXRoIGQ9Ik0xMiAxOXYtN2wtNSAtN20xMCAwbC01IDciIC8+CiAgPHBhdGggZD0iTTggMTdsOCAwIiAvPgogIDxwYXRoIGQ9Ik04IDEzbDggMCIgLz4KPC9zdmc+) - https://tabler.io/icons/icon/currency-yen
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconCurrencyYen = createReactComponent('outline', 'currency-yen', 'CurrencyYen', __iconNode);

export default IconCurrencyYen;